import medalsUrl from './medals.svg';

const SIZES = { sm: 16, md: 24, lg: 48 };
const RANK_COLORS = { gold: '#C8A24B', silver: '#C0C4C8', bronze: '#B07042' };

export default function MedalGlyph({ name = 'pr', rank, size = 'md', style, ...rest }) {
  const px = SIZES[size] || SIZES.md;
  const color = rank ? RANK_COLORS[rank] : 'var(--gold)';
  const id = name === 'rank' && rank === 'silver' ? 'medal-rank-2'
           : name === 'rank' && rank === 'bronze' ? 'medal-rank-3'
           : `medal-${name === 'rank' ? 'rank' : name}`;
  return (
    <svg
      width={px}
      height={px}
      aria-hidden={!rest['aria-label']}
      style={{ color, display: 'inline-block', flexShrink: 0, ...style }}
      {...rest}
    >
      <use href={`${medalsUrl}#${id}`} />
    </svg>
  );
}
